import React from 'react';
import { Toaster } from 'react-hot-toast';
import Lite_InjectScriptFormCont from './InjectScriptForm';
import logo from '../../assets/Logo.svg';
import illus from '../../assets/illustration374.svg';
import styles from './Lite_InjectScript.module.css';

const Lite_InjectScript = () => (
  <>
    <div className={styles.register}>
      <div className={styles['register-card']}>
        <div className={styles.images}>
          <img src={logo} alt="fewcents logo" id={styles['fewcents-logo']} />
          <h3 className={styles.title}>Monetize casual audiences</h3>
          <img
            src="https://images.fewcents.co/branding/fewcents_bridge.jpg"
            alt="fewcents bridge"
            id={styles['illustration-bridge']}
          />
        </div>
        <Lite_InjectScriptFormCont />
      </div>
    </div>
    <Toaster
      containerStyle={{
        top: 50,
        left: 20,
        bottom: 20,
        right: 20
      }}
    />
  </>
);

export default Lite_InjectScript;
